import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';
import firebase from 'firebase/compat/app';
import { Subscription } from 'rxjs';
import { FormBuilder, AbstractControl, FormsModule } from '@angular/forms';
import { UiStateService } from 'app/core/store/ui/state-service';
import { AuthStateService } from 'app/auth/store/auth.state-service';
import { ROUTE_ANIMATIONS_ELEMENTS } from 'app/core/animations/route.animations';
// import { ServiceProductStateService } from 'app/core/store/products/state-service';
import { Client } from 'app/features/admin/clients/model/Client';
import { getPDropdownItems, PDropdownItem, SinglePluralString } from 'app/core/models/common-ux-types';
import { ClientServiceType, EditingStatus } from 'app/core/models/common-types';
import * as XLSX from 'xlsx';
import { isNil } from 'app/shared/utils';
import { ExportFileService } from 'app/core/services/export-file/export-file.service';
// import { FileValidator } from 'ngx-material-file-input';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from '@core/primeng.module';
import { ClientStateService } from 'app/features/admin/clients/store/client.state-service';
import { ServiceProductListItem, ServiceProduct, adminServiceProductListDisplayColumns, userServiceProductListDisplayColumns } from '../../model/ServiceProduct';
import { getProductMaterialStr, ProductImportFileType } from 'app/features/admin/products/model/types';
import { ServiceProductStateService } from '../../store/service-products.state-service';
import { ServiceProductType, ServiceProductUomType } from '../../model/types';
import { isAdminUser } from 'app/auth/model/types';

@Component({
  selector: 'app-service-list',
  standalone: true,
  imports: [CommonModule, PrimeNgModule, FormsModule],
  templateUrl: './service-list.component.html',
  styleUrl: './service-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceListComponent implements OnInit, OnDestroy {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  displayedColumns = userServiceProductListDisplayColumns;
  dataSource: ServiceProductListItem[] = [];
  isLoading$ = this.uiStateService.isLoading$;
  isAdminUser = false;
  isClientUser = false;
  serviceProductListItems: ServiceProductListItem[] = [];
  importProductList: ServiceProduct[] = [];
  selectedServiceProduct: ServiceProductListItem;
  selectedRowIndex = '';
  fileUploads?: any[];
  tableHeight = '40rem';
  selectedAction = 'Add Item';
  selectedClient: Client;
  productSPS: SinglePluralString = getProductMaterialStr(ClientServiceType.SERVICE_OTHER);
  willDownload = false;
  serviceProductTypePDropdownItems = getPDropdownItems(ServiceProductType);
  serviceProductUomTypePDropdownItems = getPDropdownItems(ServiceProductUomType);
  selectedImportTypeDropdownItem: PDropdownItem;

  private subscriptions = new Subscription();
  constructor(
    private changeDetector: ChangeDetectorRef,
    private serviceProductStateService: ServiceProductStateService,
    private clientStateService: ClientStateService,
    private uiStateService: UiStateService,
    private authStateService: AuthStateService,
    private formBuilder: FormBuilder,
    private router: Router,
    private exportFileService: ExportFileService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    //  console.log('MS ProductTableComponent ngOnInit');
    this.updateDataSource();

    this.subscriptions.add(
      this.authStateService.loggedInUser$.subscribe((loggedInUser) => {
        if (loggedInUser) {
          this.isAdminUser = isAdminUser(loggedInUser.userType);
          this.displayedColumns = adminServiceProductListDisplayColumns;

          console.log('MS AdminViewComponent this.isAdminUser', this.isAdminUser);
          this.changeDetector.detectChanges();
        }
        // console.log('MS AdminViewComponent this.isAdminUser', this.isAdminUser);
        // this.rcAdminStateService.loadClients();
      })
    );

   3
    this.subscriptions.add(
      this.authStateService.isClientUser$.subscribe((isClientUser) => {
        this.isClientUser = isClientUser;
      })
    );
    this.subscriptions.add(
      this.clientStateService.selectedClient$.subscribe((selectedClient) => {
        // console.log('MS ProductTableComponent selectedClient = ', selectedClient);
        this.selectedClient = selectedClient;
        if (selectedClient) {
          this.productSPS = getProductMaterialStr(this.selectedClient.serviceType);
        }
      })
    );
    this.subscriptions.add(
      this.serviceProductStateService.serviceProductListItems$.subscribe((serviceProductListItems) => {
        this.serviceProductListItems = serviceProductListItems;
        console.log('MS ProductListComponent this.serviceProductListItems = ', this.serviceProductListItems);
        this.updateDataSource();
        // }
      })
    );
    // this.subscriptions.add(
    // this.fileUploadService.getFiles(6).snapshotChanges().pipe(
    //   map(changes =>
    //     // store the key
    //     changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
    //   )
    // ).subscribe(fileUploads => {
    //   console.log('MS ProductTableComponent fileUploads = ', fileUploads);
    //   this.fileUploads = fileUploads;
    // })
    // );

    // this.subscriptions.add(
    //   this.authStateService.getProducts$.subscribe(rcProducts => {
    //     this.rcProducts = rcProducts;
    //     if (rcProducts && this.customers.length > 0) {
    //       this.updateDataSource();
    //     }
    //   })
    // );
  }

  updateDataSource() {
    //   console.log('MS updateDataSource this.products = ', this.products);
    //  const rcServiceProductListItems: Product[] = [];
    // this.products.forEach(rcProduct => {
    //     rcServiceProductListItems.push(this.transformProductToListItem(rcProduct));
    // }
    // );
    this.dataSource = [...this.serviceProductListItems];
    // console.log('MS ProductListComponent this.dataSource = ', this.dataSource);
    // console.log('MS ProductListComponent this.displayedColumns = ', this.displayedColumns);
    this.changeDetector.detectChanges();
  }

  //   transformProductToListItem(rcuser: Product): ServiceProductListItem {
  //     const customer = this.customers.find(item => item.id === rcuser.customerId)
  //     // TODO DEAL WITH facilitiesNames later
  //     return {
  //       customerName: customer?.name,
  //       customerId: rcuser.customerId,
  //       displayName: rcuser.displayName,
  //       email: rcuser.email,
  //       facilities: rcuser.facilities,
  //       first: rcuser.first,
  //       last: rcuser.last,
  //       password: rcuser.password,
  //       phone: rcuser.phone,
  //       userType: rcuser.userType,
  //       id: rcuser.id,
  //       facilitiesNames: []
  //     }
  //   }

  // setPageSizeOptions(setPageSizeOptionsInput: string) {
  //   if (setPageSizeOptionsInput) {
  //     this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  //   }
  // }
  // applyFilter(filterValue: string) {
  //   filterValue = filterValue.trim(); // Remove whitespace
  //   filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  //   this.dataSource.filter = filterValue;
  // }

  // onDuplicateProduct(row: ServiceProductListItem) {
  //   this.selectedRowIndex = row.id;
  //   this.selectedServiceProduct = row;
  // }
  onExportProducts() {
    const newData = this.dataSource.map((item) => ({
      ...item,
      quantity: item.quantity > 0 ? item.quantity : 1,
    })); // need at least 1
    this.exportFileService.exportToCsv(newData, 'productList-data', ['quantity', 'itemNumber']);
  }

  onImportServiceProducts(event: Event, importFileType: any) {
    console.log('MS onImportServiceProducts importFileType= ', this.selectedImportTypeDropdownItem);
    console.log('MS onImportServiceProducts importType= ', importFileType);
    const file = (event.target as HTMLInputElement).files[0];
     console.log('MS onImportServiceProducts file = ', file);
    if (file) {
      let workBook = null;
      // let jsonData = null;
      const reader = new FileReader();
      this.importProductList = [];
      // const file = ev.target.files[0];
      reader.onload = (_event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        const sheetList = workBook.SheetNames;

        const xlData = XLSX.utils.sheet_to_json(workBook.Sheets[sheetList[0]]);
        console.log('MS onImportServiceProducts xlData= ', JSON.stringify(xlData));
        // const products: Product[] = [];
        xlData.forEach((row) => {
          // console.log('MS row= ', row);
          // switch (importFileType) {
          //   case ProductImportFileType.PLATT_ORDER: {
              if (!isNil(row['Type'])) {
                const ServiceProduct: ServiceProduct = this.processRowFromResCom(row);
                console.log('MS RESCOM ServiceProduct= ', ServiceProduct);
                this.importProductList.push(ServiceProduct);
              }
            //   break;
            // }
            // case ProductImportFileType.PLATT_CART: {
            //   if (!isNil(row['Price'])) {
            //     const product: Product = this.processRowFromPlattCart(row);
            //     // console.log('MS PLATT_CART product= ', product);
            //     this.importProductList.push(product);
            //   }
            //   break;
            // }
          // }
        });
        this.processImport();
      };
      reader.readAsBinaryString(file);
    }
  }
// Type	Uom	Item #	Style/Item	Color/Description	Inventory #	Price

  processRowFromResCom(row): ServiceProduct {
    console.log('MS processRowFromResCom row[Color/Description]= ', row['Color/Description']);
    const serviceProduct: ServiceProduct = {
      clientId: this.selectedClient.id,
      description: row['Color/Description'] ?? null,
      itemNumber: row['Item #'] ?? null,
      // itemNumber: String(row['Item #']).padStart(7, '0'), // '0010',
      price: row['Price'] ?? null,
      serviceProductType: row['Type'],
      uomType: row['Uom'],
      // sku: null,
      // manufacturer: row['Manufacturer'],
      // supplier: 'Platt',
      title: row['Style/Item'] ?? null,
      updatedTimestamp: firebase.firestore.Timestamp.now(),
    };
    return serviceProduct;
  }

  // processRowFromPlattOrder(row): Product {
  //   const product: Product = {
  //     clientId: this.selectedClient.id,
  //     description: row['Description'],
  //     itemNumber: String(row['Item #']).padStart(7, '0'), // '0010',
  //     price: row['Unit Price'],
  //     productType: ProductType.PRODUCT,
  //     sku: row['SKU'],
  //     manufacturer: row['Manufacturer'],
  //     supplier: 'Platt',
  //     title: row['SKU'],
  //     updatedTimestamp: firebase.firestore.Timestamp.now(),
  //     uomType: row['Unit of Measurement'],
  //   };
  //   return product;
  // }

  processImport() {
    console.log('MS this.importProductList= ', this.importProductList);
    if (this.importProductList.length > 0) {
      this.importProductList.forEach((newProduct) => {
        // console.log('MS newProduct= ', newProduct);
        const existingProduct = this.serviceProductListItems.find(
          (prod) => prod.itemNumber.replace(/^0+/, '') === newProduct.itemNumber.replace(/^0+/, '')
        );
        if (existingProduct) {
          // console.log('MS prod= ', existingProduct);
          const newServiceProductListItem: ServiceProductListItem = {
            ...existingProduct,
            ...newProduct,
            //   description: newProduct.description,
            // price: newProduct.price,
            // title: newProduct.title,
            updatedTimestamp: firebase.firestore.Timestamp.now(),
            // imagePath: this.editProductForm.value.imagePath
          };
          this.serviceProductStateService.updateServiceProduct(newServiceProductListItem);
        } else {
          this.serviceProductStateService.addServiceProduct(newProduct);
        }
      });
    } else {
      this.confirmationService.confirm({
        header: 'Import Products Error',
        message: 'No Products Imported! Did you select the correct Format and/or File?',
      });
    }
  }

  onRowSelect(row) {
    console.log('MS onRowSelect row.data= ', row.data);
    console.log('MS onRowSelect this.selectedClient= ', this.selectedClient);
    this.onEditServiceProduct(row.data);
  }
  onAddServiceProduct() {
    this.serviceProductStateService.setServiceProductsEditingStatus(EditingStatus.ADDING);
    this.router.navigate(['/admin/edit-service', EditingStatus.ADDING]);
  }

  onEditServiceProduct(serviceProductListItem: ServiceProductListItem) {
    console.log('MS onEditProduct serviceProductListItem= ', serviceProductListItem);
    console.log('MS onEditProduct this.selectedClient= ', this.selectedClient);
    this.serviceProductStateService.setServiceProductsEditingStatus(EditingStatus.EDITING);
    this.serviceProductStateService.setSelectedServiceProduct(serviceProductListItem);
    this.router.navigate(['/admin/edit-service', EditingStatus.EDITING]);
  }

  onDeleteAllServiceProducts() {
    if (this.serviceProductListItems?.length > 0) {
      const modalRef = this.confirmationService.confirm({
        header: `Remove ${this.productSPS.plural}`,
        message: `You are removing ALL ${this.productSPS.plural} from the database!<p><p>Do you want to continue?`,
        icon: 'pi pi-exclamation-triangle',
        acceptButtonStyleClass: 'p-button-danger p-button-text',
        rejectButtonStyleClass: 'p-button-text p-button-text',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        accept: () => {
          const productIds = this.serviceProductListItems.map((prod) => prod.id);
          // console.log('MS confirm rcProduct= ', rcProduct);
          this.serviceProductStateService.deleteMultipleServiceProducts(productIds);
        },
        reject: () => { },
      });
    }
  }
  onDeleteServiceProduct(serviceProductListItem: ServiceProductListItem) {
    const modalRef = this.confirmationService.confirm({
      header: `Remove ${this.productSPS.single}`,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      message: `You are removing ALL ${this.productSPS.single} from the database!<p><p>Do you want to continue?`,
      accept: () => {
        this.serviceProductStateService.deleteServiceProduct(serviceProductListItem.id);
      },
      reject: () => { },
    });
  }


  onDone() {
    this.router.navigate(['/admin']);
  }

  setTableHeight() {
    this.tableHeight = `${window.innerHeight - 120}px`;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setTableHeight();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private image(photoControl: AbstractControl): { [key: string]: boolean } | null {
    //  console.log('MS validateImageFile! photoControl.value = ',photoControl.value);
    if (photoControl.value) {
      const [productImage] = photoControl.value.files;
      return this.exportFileService.validateImageFile(productImage)
        ? null
        : {
          image: true,
        };
    }
    return;
  }
}

